import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import PublicHeader from "../components/PublicHeader";
import { getPublicClubPage, PublicOrganization } from "../firebase/publicDirectory";
import { useTranslation } from "../hooks/useTranslation";
import "./PublicDirectory.css";

export default function PublicClubs() {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [submittedSearch, setSubmittedSearch] = useState("");
  const [clubs, setClubs] = useState<PublicOrganization[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    setLoading(true); setError(false);
    getPublicClubPage({ search: submittedSearch }).then(setClubs).catch((err) => { console.error("Public club directory load failed", err); setError(true); }).finally(() => setLoading(false));
  }, [submittedSearch]);
  return <div className="directory-page">
    <Helmet><title>{t("publicDirectory.clubs.seoTitle")}</title><meta name="description" content={t("publicDirectory.clubs.subtitle")} /></Helmet>
    <PublicHeader />
    <header className="directory-hero"><div className="directory-hero__inner"><p className="directory-eyebrow">{t("publicDirectory.officialRegistry")}</p><h1>{t("publicDirectory.clubs.title")}</h1><p>{t("publicDirectory.clubs.subtitle")}</p></div></header>
    <main className="directory-content">
      <form className="directory-search" onSubmit={(event) => { event.preventDefault(); setSubmittedSearch(search); }}><input value={search} onChange={(event) => setSearch(event.target.value)} placeholder={t("publicDirectory.clubs.search")} aria-label={t("publicDirectory.clubs.search")} /><span aria-hidden="true">⌕</span><button type="submit">Search</button></form>
      {error && <div className="directory-error" role="alert">{t("publicDirectory.loadError")}</div>}
      <div className="directory-grid">
        {!loading && !error && clubs.length === 0 && <div className="directory-empty"><h2>{t("publicDirectory.clubs.emptyTitle")}</h2><div>{t("publicDirectory.clubs.emptyText")}</div></div>}
        {clubs.map((club) => <Link className="directory-card" to={`/clubs/${club.slug}`} key={club.id}>
          <div className="directory-card__top"><div className="directory-avatar">{club.imageUrl ? <img src={club.imageUrl} alt="" /> : club.officialName.charAt(0)}</div><div><h2>{club.officialName}</h2>{club.shortName && <span className="directory-card__id">{club.shortName}</span>}</div></div>
          <div className="directory-card__meta">{club.location && <span>{t("publicDirectory.location")}<b>{club.location}</b></span>}<span>{t("publicDirectory.country")}<b>{club.countryName || club.countryCode || "—"}</b></span></div>
          <div className="directory-card__action">{t("publicDirectory.viewClub")} →</div>
        </Link>)}
      </div>
      {loading && <div className="directory-empty">{t("publicDirectory.loading")}</div>}
    </main>
  </div>;
}
